import { translateAndSortAscendant } from "../common/helper";
import { Request, AnonymusRequest } from "./HttpService";

export const CommonService = {
  getAllAddressZone: function () {
    return Request("vitae/addressZone", "GET");
  },
  getAllMaritalStatus: function () {
    return Request("vitae/maritalStatus", "GET");
  },
  getAllSchools: function () {
    return Request("vitae/school", "GET");
  },
  getAllCourses: function () {
    return Request("vitae/course", "GET");
  },
  getAllJobRoles: function () {
    return Request("vitae/jobrole", "GET").then((data) => {
      return translateAndSortAscendant(data, "description");
    });
  },

  getAllNationalities() {
    return Request("vitae/nationality", "GET");
  },
  getAllLanguages: function () {
    return Request("vitae/language", "GET");
  },
  getAllLanguageLevels: function () {
    return Request("vitae/languagelevel"); //
  },
  LoadManagers: function () {
    return Request("userAccess/User/Managers", "GET");
  },
  getTechSkills() {
    return Request("vitae/jobroledetail/tech", "GET").then((data) => {
      return translateAndSortAscendant(data, "description");
    });
  },
  getNoticeOptions: function () {
    return Request("vitae/candidateNoticeInterview", "GET");
  },
  getInterestType: function () {
    return Request("vitae/InterestType", "GET");
  },
  getAllSkills: function () {
    return Request("vitae/personalskill", "GET");
  },
  getContractType: function () {
    return Request("vitae/contractType", "GET");
  },
  getRemoteWorkOptions: function () {
    return Request("vitae/remoteWorkOptions", "GET");
  },
  getNumberOfDependats() {
    return Request("vitae/numberofdependant");
  },
  getCandidateSources() {
    return Request("vitae/candidateSource", "GET");
  },
  getAllYearsExperience() {
    return Request("vitae/ProfessionalExperience", "GET");
  },
  getAllSeniorityLevels() {
    return Request("vitae/SeniorityLevel", "GET");
  },
  getAllDocumentTypes() {
    return Request("vitae/Documenttype", "GET");
  },
  getRecommendedCodeId() {
    return Request("vitae/candidateSource/recommendedCodeId", "GET");
  },
  getAvailabilities() {
    return Request("vitae/Availability");
  }
};

export function ConsultantCommonService(docOnlineTicket) {
  return {
    getAllSchools: function () {
      return AnonymusRequest(
        `dwork/doconline/school/${docOnlineTicket}`,
        "GET"
      );
    },
    getAllCourses: function () {
      return AnonymusRequest(
        `dwork/doconline/course/${docOnlineTicket}`,
        "GET"
      );
    },
    getTechSkills() {
      return AnonymusRequest(
        `dwork/doconline/tech/${docOnlineTicket}`,
        "GET"
      ).then((data) => {
        return translateAndSortAscendant(data, "description");
      });
    },
    getAllMaritalStatus: function () {
      return AnonymusRequest(
        `dwork/docOnline/maritalStatus/${docOnlineTicket}`,
        "GET"
      );
    },
    getAllJobRoles: function () {
      return AnonymusRequest(
        `dwork/docOnline/jobrole/${docOnlineTicket}`,
        "GET"
      ).then((data) => {
        return translateAndSortAscendant(data, "description");
      });
    }
  };
}
